import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import axios from 'axios';

interface MyEditorProps {
  initialValue?: string;
  editorChange: any;
  type?: number;
}

const TinyMceEditor: React.FC<MyEditorProps> = ({ initialValue, editorChange, type = 0 }) => {
  const editorRef = useRef(null);

  let pluginsConfig: string;
  let toolbarConfig: string;

  if (type === 1) {
    pluginsConfig = 'autolink lists link searchreplace visualblocks wordcount code';
    toolbarConfig = 'blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | align lineheight | link | removeformat | code';
  } else {
    pluginsConfig = 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount linkchecker code codesample accordion autosave visualblocks insertdatetime checklist code preview image imagetools';
    toolbarConfig = 'undo redo | blocks fontfamily fontsize | forecolor backcolor | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap hr pagebreak | removeformat | codesample accordion restoredraft visualblocks insertdatetime checklist code | preview fullscreen | save template | ltr rtl | a11ycheck | imageoptions';
  }

  const handleImageUpload = async (blobInfo: any): Promise<string> => {
    return new Promise(async (resolve, reject) => {
      const formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());

      try {
        const response = await axios.post(`${import.meta.env.VITE_API_ADM_URL}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        });

        const filename = response.data.url;
        resolve(filename);
      } catch (error) {
        if (error instanceof Error) {
          reject(`Ошибка загрузки: ${error.message}`);
        } else {
          reject('Произошла неизвестная ошибка при загрузке изображения.');
        }
      }
    });
  };

  return (
    <Editor
      licenseKey='gpl'
      tinymceScriptSrc='/assets/tinymce/js/tinymce.min.js'
      onInit={(_: any, editor: any) => (editorRef.current = editor)}
      value={initialValue}
      init={{
        height: type === 1 ? 200 : 400,
        menubar: type !== 1, // Скрываем menubar, если только форматирование
        branding: false,
        xss_sanitization: true,
        promotion: false,
        plugins: pluginsConfig,
        toolbar: toolbarConfig,
        automatic_uploads: true,
        images_upload_url: `${import.meta.env.VITE_API_URL}/upload`, 
        images_upload_handler: handleImageUpload,
        paste_data_images: true,
        imagetools_cors_hosts: ['*'],
        imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
      }}
      onEditorChange={editorChange}
    />
  );
};

export default TinyMceEditor;
